import { useEffect, useState } from 'react'
import { fetchReferralProgrammeApi } from './util'

// One request per page load, shared by the referral page and every entry
// point to it (sidebar, wallet, dashboard tab), which can all be mounted
// at once. Cleared on failure so the next mount asks again.
let programmeRequest = null

const fetchLiveProgramme = () => {
  if (!programmeRequest) {
    programmeRequest = fetchReferralProgrammeApi()
      .then((data) => (data?.is_live ? data : null))
      .catch(() => {
        programmeRequest = null
        return null
      })
  }
  return programmeRequest
}

// The running referral programme, or null when none is running. Null
// until the answer lands too, so nothing that depends on it shows and
// then vanishes.
export const useReferralProgramme = () => {
  const [programme, setProgramme] = useState(null)

  useEffect(() => {
    let active = true
    fetchLiveProgramme().then((data) => { if (active) setProgramme(data) })
    return () => { active = false }
  }, [])

  return programme
}

// Whether a referral programme is running, for links to the referral
// page: a programme that is not running has no terms to advertise.
const useReferralLive = () => Boolean(useReferralProgramme())

export default useReferralLive
